import { LOAD_MESSAGES_COUNT } from 'store/constant';
import { ChatUserModel, ChatUserModelOriginal } from 'types/chat-users/chat-user';
import { ChatUsersFiltersRequest } from 'types/chat-users/filters';
import { HistoryMessage, MessageModel } from 'types/chat/messages/message';
import { ChatUserBotStatusType, ChatUserConversation, SendMessageParamsType } from 'types/chat/props';
import { fetcher } from 'utils/axios';
import { getCurrentDateFormatted } from 'utils/helpers';

//* history messages
export async function getChatMessages(pagination: number, phoneNumber: string, count: number | null = null) {
  let result: {
    isActive: boolean | null;
    messages: HistoryMessage[];
    result: boolean;
  } = {
    isActive: null,
    messages: [],
    result: false,
  };
  try {
    const data = await fetcher(
      'get',
      `/api/whatsapp/getChatUserMsgHistoryActvStatus/${
        phoneNumber
      }/${pagination}/${count || LOAD_MESSAGES_COUNT}`,
      'history',
    );

    if (data) {
      const isActive = data.isActive;
      const messagesList = [...data.messages];
      console.log({ messagesList });
      result = {
        isActive: isActive,
        messages: messagesList,
        result: true,
      };
    }
  } catch (error) {
    console.warn('getChatMessages error: ', error);
  }

  return result;
}
export async function getChatMessagesFromId(
  id: number,
  phoneNumber: string,
  count: number | null = null,
  type: 'older' | 'newer',
) {
  let result: {
    isActive: boolean | null;
    messages: HistoryMessage[];
    result: boolean;
  } = {
    isActive: null,
    messages: [],
    result: false,
  };

  try {
    const data = await fetcher(
      'get',
      `/api/whatsapp/getChatUserMsgHistoryActvStatusByMessageId/${
        phoneNumber
      }/${id}/${count || LOAD_MESSAGES_COUNT}/${type}`,
      'history',
    );

    if (data) {
      const isActive = data.isActive;
      const messagesList = [...data.messages];

      result = {
        isActive: isActive,
        messages: messagesList ? messagesList : [],
        result: true,
      };
    }
  } catch (error) {
    console.log('getChatMessagesFromId error: ', error);
  }

  return result;
}
export async function getChatSearchMessagesArr(phoneNumber: string) {
  let result: HistoryMessage[] = [];
  try {
    const data = await fetcher(
      'get',
      ['/api/whatsapp/searchChatUserWhatsappMessage', { data: { phoneNumberId: phoneNumber } }],
      'history',
    );

    if (data) {
      result = [...data];
    }
  } catch (error) {
    console.log('searchChatUserWhatsappMessage error: ', error);
  }

  return result;
}
export const getChatMissingHistory = async (
  phoneNumber: string,
  currentMsgs: Array<HistoryMessage | MessageModel>,
) => {
  try {
    let dateFrom,
      dateTo,
      closestBufferIndex = -1;
    if (currentMsgs?.length) {
      closestBufferIndex = currentMsgs.findLastIndex((msg) => msg.FileType === 'buffer');
      const lastMessage = currentMsgs[currentMsgs.length - 1];

      dateTo = lastMessage.DateCreatedOriginal;
      dateFrom = currentMsgs[closestBufferIndex !== -1 ? closestBufferIndex + 1 : 0].DateCreatedOriginal;
    } else {
      const date = getCurrentDateFormatted();
      dateFrom = date;
      dateTo = date;
    }

    const filteredMessages =
      closestBufferIndex !== -1 ? currentMsgs.slice(closestBufferIndex + 1) : currentMsgs;
    const data = await fetcher(
      'post',
      [
        '/api/sendMessage/getMissingMessages',
        {
          data: {
            date: dateFrom,
            dateTo: dateTo,
            ids: filteredMessages.map((msg) => msg.Id),
            chatUserPhoneNumberId: phoneNumber.startsWith('972') ? '0' + phoneNumber.slice(3) : phoneNumber,
          },
        },
      ],
      'history',
    );

    if (data?.messages) {
      return data.messages as Array<HistoryMessage | MessageModel>;
    } else {
      return [];
    }
  } catch (error) {
    console.log('getChatUpdateHistory err: ', error);
    return [];
  }
};
export const fetchGetFavouriteMessages = async (page: number, number: number) => {
  try {
    const data = await fetcher(
      'get',
      ['/api/massMessaging/getFavouriteMessages', { data: { page, number } }],
      'history',
    );
    if (data) {
      return data as {
        result: boolean;
        faivourites: Array<{
          message: HistoryMessage | MessageModel;
          chatUser?: ChatUserModelOriginal | null;
          file?: string | null;
        }>;
      };
    } else return null;
  } catch (error) {
    console.warn('fetchGetFavouriteMessages error: ', error);
    return null;
  }
};
export const fetchRemoveFromFavourites = async (id: number) => {
  try {
    const data = await fetcher(
      'post',
      [
        '/api/massMessaging/updateMessageFavouriteStatus',
        {
          data: {
            id,
            isFavourite: false,
          },
        },
      ],
      'history',
    );
    if (data)
      return data as {
        result: boolean;
      };
    else return null;
  } catch (error) {
    console.warn('fetchRemoveFromFavourites error: ', error);
    return null;
  }
};

//* Send message
export async function sendChatMessage(params: SendMessageParamsType) {
  let result: boolean = false;
  try {
    const data = await fetcher(
      'post',
      ['/api/services/sendMessageRefactoring', { data: params }],
      'messages',
    );

    if (data) {
      result = data.result ?? false;
    }
  } catch (error) {
    console.log('sendChatTextMessage error: ', error);
  }

  return result;
}
export async function sendChatFileMessage(formData: FormData) {
  let result: boolean = false;
  try {
    const data = await fetcher(
      'post',
      ['/api/services/sendMessageRefactoringFile', { data: formData }],
      'messages',
    );

    if (data) {
      return data;
    }
  } catch (error) {
    console.log('sendChatTextMessage error: ', error);
  }

  return result;
}

//* Messages common
export async function fetchSetMessageFavourite(id: number, state: boolean) {
  try {
    const data = await fetcher(
      'post',
      [
        '/api/massMessaging/updateMessageFavouriteStatus',
        {
          data: {
            id,
            isFavourite: state,
          },
        },
      ],
      'history',
    );

    return data;
  } catch (error) {
    console.warn('setMessageFavourite error: ', error);
    return null;
  }
}

//* Chat users
export async function fetchGetChatUsers(params: ChatUsersFiltersRequest) {
  try {
    // POST ולא GET: ה-GET של GetCompanyChatUsersAll בשרת מקבל רק חיפוש/תגית/פתוח/לא-נקראו
    // ומתעלם מ-assigneeFilter, is_bot ו-filters. לכן התצוגות "לא משויכות", "של אחרים" ו"בוטים"
    // סוננו בדפדפן מתוך 30 השיחות הראשונות בלבד, ועם "רק לא נקראו" יצאו ריקות
    // (30 הלא-נקראות העדכניות היו כולן משויכות). פעולת ה-POST באותו נתיב מקבלת את כל המודל
    // ומסננת בשרת לפני החיתוך לעמוד.
    // dontDisturb: ב-GET הפרמטר לא נקלט כלל (שיחות "נא לא להפריע" הוצגו תמיד); ב-POST ערך false
    // היה מסתיר אותן. שולחים null כשהפילטר כבוי כדי לא לשנות את ההתנהגות הקיימת.
    const body = { ...params, dontDisturb: params.dontDisturb ? true : null };
    const data = await fetcher('post', ['/api/services/GetCompanyChatUsersAll', { data: body }], 'history');
    if (data)
      return data as {
        result: boolean;
        allChatUsers: {
          result: boolean;
          chatUsers: Array<ChatUserModel>;
        };
        myChatUsers: {
          result: boolean;
          chatUsers: Array<ChatUserModel>;
        };
      };
    else return null;
  } catch (error) {
    console.warn('fetchGetChatUsers error: ', error);
    return null;
  }
}
export const fetchGetChatUserMeta = async (phone: string) => {
  try {
    const data = await fetcher('get', `/api/services/getChatUserMetaByPhoneNumber/${phone}`, 'history');
    return data;
  } catch (error) {
    console.warn('getChatUserMeta error: ', error);
    return null;
  }
};
export const fetchGetBotStatus = async (phone: string) => {
  try {
    const data = await fetcher(
      'get',
      [
        '/api/services/getChatUserBotStatus',
        {
          data: {
            chatUserPhoneId: phone,
          },
        },
      ],
      'history',
    );
    if (data) {
      return data as ChatUserBotStatusType;
    } else return null;
  } catch (error) {
    console.warn('getChatUserMeta error: ', error);
    return null;
  }
};
export const fetchStopUserBots = async (phone: string, botId: number) => {
  try {
    const data = await fetcher(
      'post',
      [
        '/api/services/stopUserBots',
        {
          data: {
            userPhoneNumberId: phone,
            botId,
          },
        },
      ],
      'history',
    );
    if (data) return data;
    else return null;
  } catch (error) {
    console.warn('fetchStopUserBots error: ', error);
    return null;
  }
};
export const fetchGetChatUserConversations = async (phone: string) => {
  try {
    const data = await fetcher('get', `/api/services/getChatUserConversations/${phone}/1/10`, 'history');
    if (data) return data as { result: boolean; readyLogsList: Array<ChatUserConversation> };
    else return null;
  } catch (error) {
    console.warn('fetchGetChatUserConversations error: ', error);
    return null;
  }
};
export const fetchUpdateCovnersationLog = async (
  id: number,
  name: string | null,
  priority: number | null,
) => {
  try {
    const data = await fetcher(
      'post',
      [
        '/api/services/updateCovnersationLog',
        {
          data: {
            id,
            name,
            priority,
          },
        },
      ],
      'history',
    );
    if (data) return data;
    else return null;
  } catch (error) {
    console.warn('fetchUpdateCovnersationLog error: ', error);
    return null;
  }
};
export type ForwardMessagesResult = {
  result: boolean;
  partialSuccess?: boolean;
  unsupportedFileTypes?: string[];
  message?: string;
};

export const fetchForwardMessagesToChatUsers = async (
  messagesList: number[],
  chatUsersPhoneList: string[],
) => {
  try {
    const data = await fetcher(
      'post',
      [
        '/api/services/forwardMessage',
        {
          data: {
            messagesList,
            chatUsersPhoneList,
          },
        },
      ],
      'messages',
    );
    if (data) return data as ForwardMessagesResult;
    else return null;
  } catch (error) {
    console.warn('fetchForwardMessagesToChatUsers error: ', error);
    return null;
  }
};
